<template>
    <article>
        <h4>原始圖卡樣式設定</h4>
        <div class="input-container">
            <section>
                <label>									
                    叉叉顏色
                </label>
                <v-text-field
                    @change="updateStatus('marketing_card','card_close_color', card_close_color)"
					v-model="card_close_color" hide-details class="ma-0 pa-0" solo
                    @input="updateStatus('marketing_card','card_close_color', card_close_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="card_close_color_menu"
                            :colorValue="card_close_color"
                            @updateColorValue="card_close_color = $event"
                            @updateColorMenu="card_close_color_menu = $event"
                            @changeStatusColorValue="updateStatus( 'marketing_card','card_close_color', card_close_color)"
                        />
                    </template>    
                </v-text-field>
            </section>
        </div>
        <h5>
            <v-icon color="primary">
                mdi-image-outline
            </v-icon>
            圖片設定
        </h5>
        <div class="input-container">
            <section>
                <label for="input">上傳圖片</label>
                <input
                    id="input"
                    type="file"
                    accept=".png,.jpg,.jpeg,.gif"
                    name="fmslfskfk"
                    v-on:change="uploadImage"
                >
            </section>
        </div>
        <div class="input-container">
            <section>
                <label>背景顏色</label>
                <v-text-field
					v-model="card_img_bg_color" hide-details class="ma-0 pa-0" solo
                    @input="updateStatus( 'marketing_card','card_img_bg_color', card_img_bg_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="card_img_bg_color_menu"
                            :colorValue="card_img_bg_color"
                            @updateColorValue="card_img_bg_color = $event"
                            @updateColorMenu="card_img_bg_color_menu = $event"
                            @changeStatusColorValue="updateStatus( 'marketing_card','card_img_bg_color', card_img_bg_color)"
                        />
                    </template>
                </v-text-field>
                <span
                    class="disable-color"
                    v-on:click="updateStatus('marketing_card','card_img_bg_color', 'transparent')"
                    :class="{
                        label_active: card_img_bg_color === 'transparent'
                    }"
                >
                    <v-icon>
                        mdi-close-circle-outline
                    </v-icon>
                        不用顏色
                </span>
            </section>
        </div>
        <div class="input-container">
            <section>
                <label>或是圖片網址</label>
                <v-text-field
                    @change="updateStatus('marketing_card','img_url', img_url)"
                    v-model="img_url"
                    @input="updateStatus('marketing_card','img_url', img_url)"
                    hide-details class="ma-0 pa-0" solo
                >
                </v-text-field>
            </section>
        </div>
        <h5>
            <v-icon color="primary">
                mdi-format-title
            </v-icon>
            標題設定
        </h5>
        <div class="input-container">
            <section>
                <label>
                    文字內容
                </label>
                <v-text-field
                    @change="updateStatus('marketing_card','card_title', card_title)"
                    v-model="card_title"
                    @input="updateStatus('marketing_card','card_title', card_title)"
                    hide-details
                    class="ma-0 pa-0"
                    solo
                >
                </v-text-field>
            </section>
        </div>
        <div class="input-container">
            <section>

                <label>文字顏色</label>

                <v-text-field
                    @change="updateStatus( 'marketing_card','card_title_color', card_title_color)"
					v-model="card_title_color"
                    hide-details class="ma-0 pa-0"
                    solo
                    @input="updateStatus( 'marketing_card','card_title_color', card_title_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="card_title_color_menu"
                            :colorValue="card_title_color"
                            @updateColorValue="card_title_color = $event"
                            @updateColorMenu="card_title_color_menu = $event"
                            @changeStatusColorValue="updateStatus( 'marketing_card','card_title_color', card_title_color)"
                        />
                    </template>
                </v-text-field>

                <span
                    class="disable-color"
                    v-on:click="updateStatus('marketing_card','card_title_color', 'transparent')"
                    :class="{
                        label_active: card_title_color === 'transparent'
                    }"
                >
                    <v-icon>
                        mdi-close-circle-outline
                    </v-icon>
                        不用顏色
                </span>
            </section>
        </div>
        <div class="input-container">
            <section>
                <label>背景顏色</label>
                <v-text-field
                    @change="updateStatus( 'marketing_card','card_title_bg_color', card_title_bg_color)"
					v-model="card_title_bg_color" hide-details class="ma-0 pa-0" solo
                    @input="updateStatus( 'marketing_card','card_title_bg_color', card_title_bg_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="card_title_bg_color_menu"
                            :colorValue="card_title_bg_color"
                            @updateColorValue="card_title_bg_color = $event"
                            @updateColorMenu="card_title_bg_color_menu = $event"
                            @changeStatusColorValue="updateStatus( 'marketing_card','card_title_bg_color', card_title_bg_color)"
                        />
                    </template>
                </v-text-field>
                <span
                    class="disable-color"
                    v-on:click="updateStatus('marketing_card','card_title_bg_color', 'transparent')"
                    :class="{
                        label_active: card_title_bg_color === 'transparent'
                    }"
                >
                    <v-icon>
                        mdi-close-circle-outline
                    </v-icon>
                        不用顏色
                </span>
            </section>
        </div>

        <div class="input-container">
            <section>
                <label style="min-width: 4em;">文字位置</label>
                <p class="format-align-container mb-0">
                    <label
                        for="card-title-align-left"
                    >
                        <v-icon
                            :class="{
                                label_active: card_title_align == 'left'
                            }"
                        >
                            mdi-format-align-left
                        </v-icon>
                        <input
                            type="radio"
                            id="card-title-align-left"
                            value="left"
                            v-model="card_title_align"
                            @click="updateStatus('marketing_card','card_title_align', 'left')"
                        />
                    </label>
                    <label
                        for="card-title-align-center"
                    >
                        <v-icon
                            :class="{
                                label_active: card_title_align == 'center'
                            }"
                        >
                            mdi-format-align-center
                        </v-icon>
                        <input
                            type="radio"
                            id="card-title-align-center"
                            value="center"
                            v-model="card_title_align"
                            @click="updateStatus('marketing_card','card_title_align', 'center')"
                        />
                    </label>
                    <label
                        for="card-title-align-right"
                    >
                        <v-icon
                            :class="{
                                label_active: card_title_align == 'right'
                            }"
                        >
                            mdi-format-align-right
                        </v-icon>
                        <input
                            type="radio"
                            id="card-title-align-right"
                            value="right"
                            v-model="card_title_align"
                            @click="updateStatus('marketing_card','card_title_align', 'right')"
                        />
                    </label>
                </p>
            </section>
        </div>

        <h5>
            <v-icon color="primary">
                mdi-format-quote-close-outline
            </v-icon>
            行銷文字設定
        </h5>
        <div class="input-container">
            <section>
                <label>文字內容</label>
                <v-text-field
                    @change="updateStatus('marketing_card','card_hint', card_hint)"
                    v-model="card_hint"
                    @input="updateStatus('marketing_card','card_hint', card_hint)"
                    hide-details class="ma-0 pa-0" solo
                >
                </v-text-field>
            </section>
        </div>
        <div class="input-container">
            <section>
                <label>文字顏色</label>
                <v-text-field
                    @change="updateStatus( 'marketing_card','card_hint_color', card_hint_color)"
					v-model="card_hint_color" hide-details class="ma-0 pa-0" solo
                    @input="updateStatus( 'marketing_card','card_hint_color', card_hint_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="card_hint_color_menu"
                            :colorValue="card_hint_color"
                            @updateColorValue="card_hint_color = $event"
                            @updateColorMenu="card_hint_color_menu = $event"
                            @changeStatusColorValue="updateStatus( 'marketing_card','card_hint_color', card_hint_color)"
                        />
                    </template>
                </v-text-field>
                <span
                    class="disable-color"
                    v-on:click="updateStatus('marketing_card','card_hint_color', 'transparent')"
                    :class="{
                        label_active: card_hint_color === 'transparent'
                    }"
                >
                    <v-icon>
                        mdi-close-circle-outline
                    </v-icon>
                        不用顏色
                </span>
            </section>
        </div>
        <div class="input-container">
            <section>
                <label>背景顏色</label>
                <v-text-field
                    @change="updateStatus( 'marketing_card','card_hint_bg_color', card_hint_bg_color)"
					v-model="card_hint_bg_color" hide-details class="ma-0 pa-0" solo
                    @input="updateStatus( 'marketing_card','card_hint_bg_color', card_hint_bg_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="card_hint_bg_color_menu"
                            :colorValue="card_hint_bg_color"
                            @updateColorValue="card_hint_bg_color = $event"
                            @updateColorMenu="card_hint_bg_color_menu = $event"
                            @changeStatusColorValue="updateStatus( 'marketing_card','card_hint_bg_color', card_hint_bg_color)"
                        />
                    </template>
                </v-text-field>
                <span
                    class="disable-color"
                    v-on:click="updateStatus('marketing_card','card_hint_bg_color', 'transparent')"
                    :class="{
                        label_active: card_hint_bg_color === 'transparent'
                    }"
                >
                    <v-icon>
                        mdi-close-circle-outline
                    </v-icon>
                        不用顏色
                </span>
            </section>
        </div>
        <div class="input-container">
            <section>
                <label style="min-width: 4em;">文字位置</label>
                <p class="format-align-container mb-0">
                    <label
                        for="card-hint-align-left"
                    >
                        <v-icon
                            :class="{
                                label_active: card_hint_align == 'left'
                            }"
                        >
                            mdi-format-align-left
                        </v-icon>
                        <input
                            type="radio"
                            id="card-hint-align-left"
                            value="left"
                            v-model="card_hint_align"
                            @change="updateStatus('marketing_card','card_hint_align', 'left')"
                        />
                    </label>
                    <label
                        for="card-hint-align-center"
                    >
                        <v-icon
                            :class="{
                                label_active: card_hint_align == 'center'
                            }"
                        >
                            mdi-format-align-center
                        </v-icon>
                        <input
                            type="radio"
                            id="card-hint-align-center"
                            value="center"
                            v-model="card_hint_align"
                            @change="updateStatus('marketing_card','card_hint_align', 'center')"
                        />
                    </label>
                    <label
                        for="card-hint-align-right"
                    >
                        <v-icon
                            :class="{
                                label_active: card_hint_align == 'right'
                            }"
                        >
                            mdi-format-align-right
                        </v-icon>
                        <input
                            type="radio"
                            id="card-hint-align-right"
                            value="right"
                            v-model="card_hint_align"
                            @change="updateStatus('marketing_card','card_hint_align', 'right')"
                        />
                    </label>
                </p>
            </section>
        </div>
        <h5>
            <v-icon color="primary">
                mdi-message-processing-outline
            </v-icon>
            內文設定
        </h5>
        <div class="input-container">
            <section>
                <label>背景顏色</label>
                <v-text-field
                    @change="updateStatus( 'marketing_card','card_content_bg_color', card_content_bg_color)"
					v-model="card_content_bg_color" hide-details class="ma-0 pa-0" solo
                    @input="updateStatus( 'marketing_card','card_content_bg_color', card_content_bg_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="card_content_bg_color_menu"
                            :colorValue="card_content_bg_color"
                            @updateColorValue="card_content_bg_color = $event"
                            @updateColorMenu="card_content_bg_color_menu = $event"
                            @changeStatusColorValue="updateStatus( 'marketing_card','card_content_bg_color', card_content_bg_color)"
                        />
                    </template>    
                </v-text-field>
                <span 
                    class="disable-color"	
                    v-on:click="updateStatus('marketing_card','card_content_bg_color', 'transparent')"
                    :class="{
                        label_active: card_content_bg_color === 'transparent'
                    }"									
                >
                    <v-icon>
                        mdi-close-circle-outline
                    </v-icon>
                        不用顏色	
                </span>								
            </section>					
        </div>
        <Editor 
            :init="init"
            v-model="tinymce_content"
            @input="updateStatus('marketing_card','tinymce_content', tinymce_content)"
        >
        </Editor>
    </article>    
</template>

<script>

import {
    apiUploadImage
} from '@/api/common.js'

import { mapState,mapGetters } from 'vuex';
import ColorPicker from "@/components/Utils/ColorPicker.vue"


// 引入tinymce編輯器
	import tinymce from 'tinymce/tinymce'
	import Editor from '@tinymce/tinymce-vue'
	import 'tinymce/themes/silver/theme.min.js'
	import 'tinymce/icons/default'
	import 'tinymce/skins/ui/oxide/skin.min.css'	
	import 'tinymce/plugins/image'
	import 'tinymce/plugins/link'
	import 'tinymce/plugins/code'
	import 'tinymce/plugins/table'
	import 'tinymce/plugins/lists'
	import 'tinymce/plugins/wordcount'
	import 'tinymce/plugins/fullscreen'
	import 'tinymce/plugins/preview'
	import 'tinymce/plugins/visualblocks'

export default {
    props: {
        oldSettingData: Object,
        loadOldSettingData: Boolean,
        timeLineMode: String
    },
    name: 'MarketingCardOriginalCardStyle',
    components: {
        Editor,
        ColorPicker
    },
    data() {
        return{

            mode: 'rgba',
            /* 原始圖卡圖片 */
            card_img_src: 'https://pic.optimize99.com/api/img/_/cmp/1690251392463.jpg',

            /* 原始圖卡圖片背景顏色 */
            card_img_bg_color: '#FFFFFF',

            /* 原始圖卡標題設定 */
            card_title: '圖卡標題',
            card_title_color: '#000',
            card_title_bg_color: '#FFFFFF',
            card_title_align: 'left',

            /* 原始圖卡行銷文字設定 */
            card_hint:'行銷文字',
            card_hint_color: '#000',
            card_hint_bg_color: '#FFFFFF',
            card_hint_align:'center',

            /* 原始圖卡內文設定 */
            card_content_bg_color: '#FFFFFF',

            // 圖片網址
		    img_url: '',

            /* 圖卡叉叉顏色 */
      	    card_close_color: '#000',

            /* tinymce輸入內容的變數 */
            tinymce_content: '<p>圖卡內文</p>',

            /* tinymce初始設定檔 */
            init: {
                selector: '#tinymce',
                language_url: '/tinymce/langs/zh_TW.js',
                language: 'zh_TW', 
                skin_url: '/tinymce/skins/ui/oxide',
                height: "200px",
                branding: false,
                menubar: false,
                plugins: 'link,lineheight',
                toolbar:'undo redo| fontsizeselect | forecolor |  bold italic underline | link |lineheightselect',
                content_style: "p { margin:0px;padding:0px; line-height: 1.3;}",
                lineheight_formats: "1pt 2pt 3pt 4pt 5pt 6pt 7pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 17pt 18pt 20pt 22pt 24pt 26pt",
                external_plugins: {
                    'lineheight': '/tinymce/lineheight/plugin.js'
                },
            },

            /* 監聽它來判斷是否需要載入舊設定檔，會從父組件傳值進來 */
            load_old_setting_data: false,

            card_close_color_menu: false,
            card_img_bg_color_menu: false,
            card_title_color_menu: false,
            card_title_bg_color_menu: false,
            card_hint_color_menu: false,
            card_hint_bg_color_menu: false,
            card_content_bg_color_menu: false,

            parseKey: {
                "活動預熱" : 'warmUpCardSetting',
                "活動進行" : 'activityCardSetting',
                "活動結束" : 'endUpCardSetting'
            }
        }
    },
    methods: {
        async updateStatus(state, key, value) {
            await this.changeStatus(state, key, value)
            await this.$emit('save-time-line-setting')
        },
        /**
		 * 2021-10-15 created by Watson 
		 *
		 * 說明: 上傳圖卡圖片的程式
		 *
		*/     	
    	uploadImage: async function(e) {
            // let that = this;
            console.log(e);
			var data = new FormData();
			let files = e.target.files || e.dataTransfer.files;
            console.log(files);
			if (files[0] === undefined) {
				this.card_img_src = '';
				return
			}
			data.append("file", files[0])
            data.append("category", this.$route.params.container_id)

            try {
                let result = await apiUploadImage(data)
                console.log('upload_result:', result)
                this.updateStatus('marketing_card','img_url', result)
                this.updateStatus('marketing_card','get_ele_innerHTML', true)

            } catch (error) {
                this.$root.vtoast.show({
                    message: "上傳圖片失敗，原因: " + error
                })
            }

            // const REQUEST_URL = 'https://adapi.isp99.com/api/img/pic/compress'
		    // const authorization = localStorage.getItem('authorization_token')
            // console.log(data);

            // fetch(REQUEST_URL, {
            //     method: 'POST',
            //     headers: {
            //       'Authorization': "Bearer " + authorization,
            //     //   'content-type': 'multipart/form-data',
            //     },
            //     body: data,
            //     Referer: 'https://adapi.isp99.com/ad/',
            //     Origin: 'https://adapi.isp99.com'
            // })
            // .then( res => res.json() )
            // .then( async resp => {
            //     console.log(resp);
			// 	let location = await resp.location;
			// 	console.log(location);
			// 	console.log(process.env.VUE_APP_API_EXTERNAL_ENDPOINT)
			// 	let img_src = await process.env.VUE_APP_API_EXTERNAL_ENDPOINT + location;
			// 	console.log(img_src);
			// 	// this.card_img_src = img_src;
            //     await this.updateStatus('marketing_card','img_url', img_src)
            //     await this.updateStatus('marketing_card','get_ele_innerHTML', true)
                
            // })
            // .catch((error) => {
            //     console.log(error);
            // })
			
    	},
        changeStatus: function(param_name, field_name, new_value){
            // console.log(this.card_close_color);
            // let tmp = JSON.parse(JSON.stringify(this.$store.getters.marketing_card)) 
            // tmp[field_name] = new_value
            // this.$store.commit(param_name, tmp)
            // console.log('after_commit', this.$store.getters[param_name])
            // this.$nextTick(() => {
                let tmp = JSON.parse(JSON.stringify(this.$store.getters.marketing_card)) 
                tmp[field_name] = new_value
                console.log(field_name)
                console.log(new_value)
                this.$store.commit(param_name, tmp)
                console.log('after_commit', this.$store.getters[param_name])
            // })
        },
        async loadOldMarketingCardSettingData() {
            // alert('loadOldMarketingCardSettingData');
            console.log('card_style_oldSettingData', this.oldSettingData);
            console.log('card_style_this.timeLineMode',this.timeLineMode);

            let origin_card_html = await this.oldSettingData !== null ? this.oldSettingData['card_content'] : this[this.parseKey[this.timeLineMode]]['card_content']
            // console.log(origin_card_html);

            // 沒東西就直接reutrn 下面不做事 防止報錯
            if (!origin_card_html) return

            let card = this.$utils.createDomByHtmlString(origin_card_html)

            /* 叉叉顏色 */
            let close_color = card.getElementsByClassName('card-header')[0].getElementsByTagName('i')[0].style.color;

            let tmp_color = this.$utils.rgbStingToArray(close_color);
            this.marketing_card.card_close_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
            this.card_close_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()

            console.log('573行',this.card_close_color)

            /* 圖片背景顏色 */

            let img_bg_color = card.getElementsByClassName('card-img')[0].style.backgroundColor

            if (img_bg_color === 'transparent' || img_bg_color === '') {
                this.marketing_card.card_img_bg_color = 'transparent'
                this.card_img_bg_color = 'transparent'
            } else {
                let tmp_color = this.$utils.rgbStingToArray(img_bg_color);
                this.marketing_card.card_img_bg_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
                this.card_img_bg_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
                console.log(this.card_img_bg_color)     				
            }

            /* 圖片連結 */

            let img_src = card.getElementsByTagName('img')[0].src
            console.log('img_src')
            this.marketing_card.img_url = img_src;
            this.img_src = img_src;
            this.img_url = img_src

            /* 標題 */

            /* 文字 */
            let card_title = card.getElementsByClassName('card-header')[0].getElementsByTagName('h3')[0].textContent.replace(/[\n\r]+|[\s]{2,}/g, '');
            console.log(card_title);
            this.marketing_card.card_title = card_title;
            this.card_title = card_title;
            console.log('this.card_title',this.card_title);

            /* 文字顏色 */

            let title_color = card.getElementsByClassName('card-header')[0].style.color;

            if (title_color === 'transparent' || title_color === '') {
                this.marketing_card.card_title_color = 'transparent'
                this.card_title_color = 'transparent'
            }
            else {
                let tmp_color = this.$utils.rgbStingToArray(title_color);
                this.marketing_card.card_title_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
                this.card_title_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
                console.log(this.card_title_color)    
            }

            /* 背景顏色 */

            let title_bg_color = card.getElementsByClassName('card-header')[0].style.backgroundColor;

            if (title_bg_color === 'transparent' || title_bg_color === '') {
                this.marketing_card.card_title_bg_color = 'transparent'
                this.card_title_bg_color = 'transparent'
            }
            else {
                let tmp_color = this.$utils.rgbStingToArray(title_bg_color);
                this.marketing_card.card_title_bg_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
                this.card_title_bg_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
                console.log(this.card_title_bg_color)    
            }

            /* 文字對齊方式 */

            let title_bg_align = card.getElementsByClassName('card-header')[0].getElementsByTagName('h3')[0].style.textAlign;
            this.marketing_card.card_title_align = title_bg_align;
            this.card_title_align = title_bg_align;

            /* 行銷文字 */

            /* 文字 */
            let text = card.getElementsByClassName('card-footer')[0].getElementsByTagName('h3')[0].textContent.replace(/[\n\r]+|[\s]{2,}/g, '')
            console.log(card.getElementsByClassName('card-footer')[0].getElementsByTagName('h3')[0])
            console.log(text.length)
            console.log('card_style_card_hint', text )

            this.marketing_card.card_hint = text;
            this.card_hint = text;

            /* 文字顏色 */

            let color = card.getElementsByClassName('card-footer')[0].getElementsByTagName('h3')[0].style.color;

            if (color === 'transparent' || color === '') {
                this.marketing_card.card_hint_color = 'transparent';
                this.card_hint_color = 'transparent';
            }
            else {
                let tmp_color = this.$utils.rgbStingToArray(color);
                this.marketing_card.card_hint_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
                this.card_hint_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
                console.log(this.card_hint_color)    
            }

            /* 背景顏色 */

            color = card.getElementsByClassName('card-footer')[0].style.backgroundColor;

            if (color === 'transparent' || color === '') {
                this.marketing_card.card_hint_bg_color = 'transparent';
                this.card_hint_bg_color = 'transparent';
            }
            else {
                let tmp_color = this.$utils.rgbStingToArray(color);
                this.marketing_card.card_hint_bg_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
                this.card_hint_bg_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
                console.log(this.card_hint_bg_color)    
            }

            /* 對齊方式 */ 	

            let align = card.getElementsByClassName('card-footer')[0].getElementsByTagName('h3')[0].style.textAlign;
            this.marketing_card.card_hint_align = align
            this.card_hint_align = align

            /* 內文 */

            /* 背景顏色 */

            color = card.getElementsByClassName('card-text')[0].getElementsByTagName('section')[0].style.backgroundColor;

            if (color === 'transparent' || color === '') {
                this.marketing_card.card_content_bg_color = 'transparent';
                this.card_content_bg_color = 'transparent';
            }
            else {
                let tmp_color = this.$utils.rgbStingToArray(color);
                this.marketing_card.card_content_bg_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
                this.card_content_bg_color = this.$utils.rgbToHex(parseInt(tmp_color[0]),parseInt(tmp_color[1]), parseInt(tmp_color[2])).toUpperCase()
                console.log(this.card_content_bg_color)    
            }

            /* 文字內容 */

            text = card.getElementsByClassName('card-text')[0].getElementsByTagName('section')[0].innerHTML;
            this.marketing_card.tinymce_content = text;
            this.tinymce_content = text;
            console.log(text);
        }
    },
    created() {
        
    },
    async mounted() {
        tinymce.init({});
        console.log('card_style',this.load_old_setting_data);
        // this.img_url = this.loggedInfo?.['default_value']?.['containersValue']?.[this.selectedContainer?.['name']]?.['card_image'] || ""
        // console.log('img_url',this.img_url);

        // if (this.img_url !== "") {
        //     console.log(this.marketing_card);
        //     this.$nextTick( async () => {
        //         this.card_img_src = this.img_url
        //         this.marketing_card.img_url = this.img_url
        //         await this.updateStatus('marketing_card','img_url', this.img_url)
        //         // await this.updateStatus('marketing_card','get_ele_innerHTML', true)
        //     })
        // }

        if (this.load_old_setting_data) {
            this.loadOldMarketingCardSettingData()
        }
    },
    computed: {
        ...mapState(['is_auto_coupon','marketing_card',]),
        ...mapGetters(['warmUpCardSetting','activityCardSetting','endUpCardSetting'])
    },
    watch: {
        loadOldSettingData: {
            handler: function(newValue) {
                this.load_old_setting_data = newValue
            },
            immediate: true
        },
        load_old_setting_data: {
            handler: function(newValue) {
                // if (newValue) {
                    console.log(newValue);
                    // alert('this.loadOldMarketingCardSettingData()')
                    this.loadOldMarketingCardSettingData()
                // }
            },
            immediate: true
        },
        timeLineMode: {
            handler: function(newValue) {
                console.log(newValue);
                this.loadOldMarketingCardSettingData()
            },
            // immediate: true
        }
    }
}
</script>

<style scoped>
    .preview-hint-container > h4{
        display: flex;
        align-items: center;
        margin-top: 0.5em;

    }
    .preview-hint-container > h4 > i {
        margin-right: 0.5em;
    }
    .preview-container, .setting-container {
        display: flex;
        flex-direction: column;
    }
    .setting-container {
        width: 100%;
        overflow: hidden;
    }
    .setting-main {
        overflow: scroll;
    }
    .setting-main > article{
        background-color: #FFFFFF;
        border-bottom:1px #CCC solid;
        padding: 1em;
        overflow: scroll;
    }
    .setting-main > article:last-child {
        border-bottom: none;
    }
    .setting-main > article > h4 {
        padding-bottom:1em;
        font-weight: 600;
        font-size: 1.4em;
    }
    .setting-main > article > h5 {
        padding-bottom:1em;
        font-weight:500;
        font-size: 1.1em;
        display: flex;
    }
    .setting-main > article > h5 > i {
        color: #409aff;
        margin-right: 0.5em;
    }

    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .basic-setting-title {	
        display: flex;
    }
    .basic-setting-title > span {
        display: flex;
        align-items: center;
        font-size: 0.7em;
        color: #409aff;
        margin-left: 0.5em;
    }
    .basic-setting-title > span > i{

        font-size: 18px;
        margin-right: 5px;

    }
    .basic-setting-title > span > a{

        font-weight: 200;
        outline: none;
        text-decoration: none;
        color: #409aff;

    }
    .basic-setting-title > span > a:hover {
        text-decoration: underline;
    }
    .input-container {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-bottom: 1em;
        /* margin-top: 1em; */
    }
    .input-container > section {
        display: flex;
        width: 100%;
        flex-direction: row;
        margin-right: 1em;
        align-items: center;
        /* margin-top: 1em; */
    }
    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .input-container > section > label > i {
        margin-right: 0.3em;
        color: #409aff;
    }
    .input-container > section > label {
        min-width: 6em;
        display: flex;
        align-items: center;
        font-weight: 200;
        margin-right: 0.5em;
    }
    .input-container > section > input[type="text"] {
        padding: 10px 18px 10px 18px;
        border-radius: .4285rem;
        border-color: #2b3553;
        border: 1px solid #cad1d7;
        width: 100%;
        outline: none;
        transition: all .3s;
    }
    .input-container > section > input[type="text"]:hover, .input-container > section > input[type="text"]:focus{
        border-color: #409aff;
    }

    .input-container > section > .mx-datepicker {
        width: 100%;
    }

    .disable_margin {
        margin: 0px;
    }
    .disable-color {
        min-width: 7em;
        cursor: pointer;
        color: #000;
        margin-left: 1em;
        font-size: 15px;
        display: flex;
        flex-direction: row;
        align-items: center;
        transition: all .2s;
    }
    .format-align-container {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .format-align-container > label {
        display: flex;
        margin-right: 0.5em;
        transition: all .2s;
    }
    .format-align-container > label > input[type="radio"] {
        display: none;
    }
    .label_active {
        color: #ea8181;
    }
</style>